import React from 'react';

import { Link } from '@neptune/shared/venus-ui';

// https://stackoverflow.com/a/3809435
const linkRe =
  /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/;

export const TextWithLinks = React.memo(function TextWithLinks({
  children: s,
}: {
  children: string;
}): React.ReactElement {
  let m: RegExpMatchArray | null;
  const re = new RegExp(linkRe, 'g');

  let i = 0;

  const nodes: React.ReactNode[] = [];

  while ((m = re.exec(s))) {
    const from = re.lastIndex - m[0].length;
    const to = re.lastIndex;

    if (from > i) {
      nodes.push(s.slice(i, from));
    }

    nodes.push(
      <Link key={from} external href={m[0]}>
        {m[0]}
      </Link>,
    );

    i = to;
  }

  if (i < s.length) {
    nodes.push(s.slice(i));
  }

  return <>{nodes}</>;
});

export function renderTextWithLinks(s: string) {
  return <TextWithLinks>{s}</TextWithLinks>;
}
